var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useReducer } from "react";
import classnames from "classnames";
import { tReact } from '@mp/locale';
import { Loader } from "../../Loader/Loader";
import ViewMore from "./ViewMore";
var totalViewable = 7;
function showAllDefault(selectedSlot, selectedDate, contractAccount) {
    var _a;
    if (contractAccount) {
        // If selectedSlot.inPolicy is undefined or true show limited list.
        // If seletedSlot.inPolicy is !undefined and false. Show full.
        return ((_a = selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.inPolicy) !== null && _a !== void 0 ? _a : true) ? false : true;
    }
    if (!(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.availableSlots)) {
        return false;
    }
    // Open if selected time is outside the initial options
    var index = selectedDate.availableSlots.findIndex(function (slot) {
        return (slot === null || slot === void 0 ? void 0 : slot.startTime) === (selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.startTime);
    });
    return index >= totalViewable;
}
export default function SchedulerSlots(_a) {
    var order = _a.order, selectedDate = _a.selectedDate, selectedSlot = _a.selectedSlot, setSelectedSlot = _a.setSelectedSlot;
    var contractAccount = (order === null || order === void 0 ? void 0 : order.pricing_type) === 'Contract';
    var _b = useReducer(function (state) { return !state; }, showAllDefault(selectedSlot, selectedDate, contractAccount)), viewAll = _b[0], toggleViewAll = _b[1];
    var filterSlots = function (slots) {
        if (viewAll) {
            return slots;
        }
        if (contractAccount) {
            return slots.filter(function (slot) { return slot.inPolicy; });
        }
        return slots.slice(0, totalViewable);
    };
    if (selectedDate.disabled) {
        return (_jsx("div", __assign({ className: "mp-scheduler-content" }, { children: _jsx("div", __assign({ className: "mp-scheduler-unavailable-message" }, { children: _jsx("p", { children: tReact("CAPTURE_SERVICES.SCHEDULER.unavailableMessageDay") }) })) })));
    }
    if (!(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.availableSlots)) {
        return _jsx(Loader, { loaderType: "bounce" });
    }
    return (_jsxs("div", __assign({ className: "mp-scheduler-content" }, { children: [_jsx("div", __assign({ className: "mp-scheduler-slots-list" }, { children: selectedDate.availableSlots &&
                    filterSlots(selectedDate.availableSlots).map(function (slot) { return (_jsx("button", __assign({ id: "mp-scheduler-date-time-".concat(slot.formatted
                            .split(" ")
                            .join("-")), className: classnames("mp-scheduler-slot", {
                            "is-notInPolicy": !slot.inPolicy,
                            "is-disabled": slot.disabled,
                            "is-selected": (slot.datetime && slot.datetime.toString()) ===
                                (selectedSlot.datetime && selectedSlot.datetime.toString()),
                        }), type: "button", onClick: function () { return setSelectedSlot(slot); } }, { children: slot.formatted }), slot.datetime.toString())); }) })), _jsx("div", __assign({ className: "mp-scheduler-slots-list-actions" }, { children: _jsx(ViewMore, { contractAccount: contractAccount, selectedDate: selectedDate, toggleViewAll: toggleViewAll, totalViewable: totalViewable, viewAll: viewAll }) }))] })));
}
